import { ElementType } from 'react';
import {
  PiHeartDuotone,
  PiUserDuotone,
  PiAirplaneTiltDuotone,
  PiBellDuotone,
  PiBookDuotone,
} from 'react-icons/pi';

import { routes } from '@/routes/paths';

interface MenuItem {
  header: string;
  section: {
    name: string;
    href: string;
    hrefAliases?: string[];
    icon: ElementType;
  }[];
}

export const menu: MenuItem[] = [
  {
    header: 'Flights',
    section: [
      {
        name: 'Home',
        href: routes.fights.home,
        icon: PiAirplaneTiltDuotone,
      },
      {
        name: 'Deals',
        href: routes.fights.deals,
        icon: PiBellDuotone,
      },
      {
        name: 'Saved',
        href: routes.fights.saved,
        icon: PiHeartDuotone,
      },
      {
        name: 'Guides',
        href: routes.fights.guides.root,
        icon: PiBookDuotone,
      },
      {
        name: 'Account',
        href: routes.fights.account,
        icon: PiUserDuotone,
      },
    ],
  },
];
